const query = (id, isPreview) => `
{
    globalNewsSection(id: "${id}", preview: ${isPreview}){
      heading
      variant
      seeMoreLink {
        name
        url
        label
        title
        target
        scrollToElementId
        imageType
        gaEventClass
        gaEventLabel
      }
      }
}



`
module.exports = { query }